export class WorkspaceStore {
  private static idKey = "workspace_id"

  static setWorkspaceId = (workspaceId: string): void => localStorage.setItem(WorkspaceStore.idKey, workspaceId)
  static getWorkspaceId = (): string | undefined => localStorage.getItem(WorkspaceStore.idKey) ?? undefined
  static clearWorkspaceId = (): void => localStorage.removeItem(WorkspaceStore.idKey)
  static hasWorkspaceId = (): boolean => localStorage.hasItem(WorkspaceStore.idKey)
}
